import { render, staticRenderFns } from "./AGCLabel.vue?vue&type=template&id=2218706a&scoped=true&"
import script from "./AGCLabel.vue?vue&type=script&lang=js&"
export * from "./AGCLabel.vue?vue&type=script&lang=js&"
import style0 from "./AGCLabel.vue?vue&type=style&index=0&id=2218706a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2218706a",
  null
  
)

export default component.exports